import { withAITracking } from '@microsoft/applicationinsights-react-js';
import ArrowForward from '@mui/icons-material/ArrowForward';
import SchoolIcon from '@mui/icons-material/School';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useProductCenterApi } from 'api';
import { doNotRefetch } from 'api/ReactQueryOptions';
import { trainingsQuery } from 'api/queries';
import { reactPlugin } from 'main/azureInsights/config';
import TitleWrapper from 'main/layout/TitleWrapper';
import { home_HomeUrl } from 'main/routes/urls/RouteUrls';

const TrainingsPage = (): React.JSX.Element => {
	const { t } = useTranslation(['home', 'commonButton']);
	const { api } = useProductCenterApi();

	const { data } = useSuspenseQuery({
		...trainingsQuery(api),
		retry: 1,
		...doNotRefetch,
	});

	return (
		<>
			<TitleWrapper category={t('root-title')} title={t('traingins')} />
			<Typography sx={{ width: '50%' }}>
				{t('home:content-training-text1')}
			</Typography>
			<Typography sx={{ marginBottom: '2em', width: '50%' }}>
				{t('home:content-training-text2')}
			</Typography>

			{data.map(({ id, title, trainingNumber, url }) => (
				<Box
					key={id}
					className="trainings-display_root"
					sx={{
						display: 'grid',
						alignItems: 'center',
						padding: 2,
						gridTemplateColumns: {
							xs: '2fr 2fr 1fr',
							md: '2fr 2fr 1fr',
						},

						borderBottom: '1px solid gray',
					}}>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
						}}>
						<SchoolIcon
							color="action"
							fontSize="large"
							sx={{
								marginRight: '1em',
							}}></SchoolIcon>
						<Typography>{title}</Typography>
					</Box>
					<Typography>{trainingNumber}</Typography>
					<Button
						variant="text"
						href={url ?? ''}
						endIcon={<ArrowForward />}>
						{t('commonButton:open')}
					</Button>
				</Box>
			))}

			<Box
				sx={{
					width: '80%',
					alignSelf: 'center',
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-end',
					marginTop: '1em',
				}}>
				<Button
					variant="text"
					to={home_HomeUrl}
					component={Link}
					endIcon={<ArrowForward />}
					sx={{
						fontSize: '20px',
					}}>
					{t('commonButton:back')}
				</Button>
			</Box>
		</>
	);
};

export default withAITracking(
	reactPlugin,
	TrainingsPage,
	'TrainingsPage',
	'application-insight-container'
);
